import http from '@/services/http/http'

export async function listEcashTransactions(opts) {
  const url = '/api/v1/ecash_transactions'
  const { data } = await http.get(url, {params: opts})
  return data
}